import { render, staticRenderFns } from "./OwalPanelCarousel.vue?vue&type=template&id=7188c896&scoped=true"
import script from "./OwalPanelCarousel.vue?vue&type=script&lang=js"
export * from "./OwalPanelCarousel.vue?vue&type=script&lang=js"
import style0 from "./OwalPanelCarousel.vue?vue&type=style&index=0&id=7188c896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188c896",
  null
  
)

export default component.exports